import { useTranslation } from 'react-i18next';
import { useModal, useProfile } from '@/hooks';
import { Form, Input, Radio, ReformSubmitHandler, Submit } from '@kodkafa/reform';
import { useEffect } from 'react';
import {
  UpdateWalletDto,
  useGiveawayControllerSetWalletForRewardMutation,
} from '@/store/services/MidleNestApi.service';
import { useNavigate, useParams } from 'react-router-dom';

export default function SetWalletComponent() {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { hideModal } = useModal('set-wallet');

  const [updateWallet, { isLoading, isSuccess }] = useGiveawayControllerSetWalletForRewardMutation(
    {},
  );
  const { profile } = useProfile();
  const loginWallet = profile.user.accounts.find((x) => x.provider == 'wallet')?.identity;
  const onSubmitHandler: ReformSubmitHandler<
    UpdateWalletDto & { selection: string; loginWallet: string; newWallet: string }
  > = async (data, setError) => {
    if (isLoading) return;
    if (!data.selection) return;

    data.wallet = data.selection === 'loginWallet' ? data.loginWallet : data.newWallet;
    console.warn(data.wallet);

    if (!data?.wallet?.match(/^(0x[a-f0-9]{40})$/i))
      return setError(data.selection, { message: 'Wallet must be in Ethereum address format!' });

    await updateWallet({
      wallet: data.wallet,
      rewardId: id ? id : '',
    })
      .unwrap()
      .then((res) => {
        navigate('/settings/rewards');
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (isSuccess) hideModal();
  }, [isSuccess]);

  return (
    <div className='flex flex-col px-8 py-2 gap-y-8'>
      <h2 className='text-center text-lg leading-5 font-semibold'>{t('Select Wallet')}</h2>
      <Form onSubmit={onSubmitHandler} className='flex flex-col gap-y-4'>
        <Radio
          type='radio'
          name='selection'
          value='loginWallet'
          label={t('I want to receive my rewards to wallet I`ve connected to Midle.')}
        />
        <Input
          name='loginWallet'
          value={loginWallet}
          readOnly
          className='rounded-lg border border-gray-300 px-4'
        />
        <Radio
          type='radio'
          name='selection'
          value='newWallet'
          label={t('I prefer my rewards to be sent to the BEP-20 wallet address below.')}
        />
        <Input
          name='newWallet'
          placeholder='Wallet'
          className='rounded-lg border border-gray-300 px-4'
        />
        <Submit
          className='mt-8 disabled:cursor-not-allowed disabled:grayscale'
          disabled={isLoading}
        >
          {t('Update Wallet')}
        </Submit>
      </Form>
    </div>
  );
}
